import React, {useState, Fragment} from 'react'
import styles from './TRouteCues.scss'
import {Icon} from 'common/Icon'
import {CueIcon} from 'common/CueIcon'
import {FullBleedList} from 'features/routes/RouteShowPage/SidePanel/FullBleedList'
import {Distance} from 'common/units'
import {featureTypes} from 'common/MapV2/featureTypes.js'

export class TRouteCues extends React.PureComponent {
  onCoursePointHovered = (index) => {
    const {onFeatureHovered, troute} = this.props
    if (index === null) {
      onFeatureHovered(null)
      return
    }
    onFeatureHovered({
      type: featureTypes.CUE,
      data: {
        index,
        coursePoint: troute.coursePoints[index]
      }
    })
  }

  onCoursePointClicked = (index) => {
    const {onFeatureSelected, troute} = this.props
    onFeatureSelected({
      type: featureTypes.CUE,
      data: {
        index,
        coursePoint: troute.coursePoints[index]
      }
    })
  }

  render () {
    const {troute} = this.props
    const editable = false

    return (
      <Fragment>
        {troute.coursePoints && troute.coursePoints.length > 0 && <div>
          <h2>Cuesheet</h2>
          <Cuesheet
            coursePoints={troute.coursePoints}
            onCoursePointHovered={this.onCoursePointHovered}
            onCoursePointClicked={this.onCoursePointClicked} />
        </div>}
        {troute.coursePoints && troute.coursePoints.length === 0 && <div className={styles.Cuesheet}>
          <h2>Cuesheet</h2>
          {editable
            ? <p>This route does not have a cuesheet. Visit our <a href='https://ridewithgps.com/help/trace-tool' target='_blank'>help page</a> to learn how to add a cuesheet to this route.</p>
            : <p>This route does not have a cuesheet. Look for the <Icon className={styles.light} i='md-document' data-tip title='Cuesheet' /> icon in listings to find routes with cuesheets.</p>}
        </div>}
      </Fragment>
    )
  }
}

const Cuesheet = ({coursePoints, onCoursePointHovered, onCoursePointClicked}) => {
  const [expanded, setExpanded] = useState(false)
  const points = expanded ? coursePoints : coursePoints.slice(0, 5)

  return (
    <div className={styles.Cuesheet}>
      <FullBleedList interactive expanded={expanded}>
        {points.map((cp, index) => (
          <li key={cp.i}
            onClick={() => onCoursePointClicked(index)}
            onMouseOver={() => onCoursePointHovered(index)}
            onMouseOut={() => onCoursePointHovered(null)}>
            <div className={styles.cueIcon}><CueIcon type={cp.t} className={styles.cueImg} /></div>
            <div className={styles.cueText}>{cp.n}</div>
            <div style={{flex: '0 0 auto'}}><Distance value={cp.d} bigUnits maximumFractionDigits={1} minimumFractionDigits={1} short /></div>
          </li>
        ))}
      </FullBleedList>
      {coursePoints.length > 5 && <div className={styles.expandlink}>
        <a onClick={() => setExpanded(!expanded)}>{expanded ? 'Collapse Cuesheet' : 'Show Full Cuesheet'}</a>
      </div>}
    </div>
  )
}
